import React from 'react'
import { CheckIcon, XIcon } from 'lucide-react'

export function BasicFlagField({ value }: { value: boolean }) {
	if (value === undefined || value === null) {
		return <>-</>
	}

	return value ? (
		<CheckIcon className='size-4 text-success' />
	) : (
		<XIcon className='size-4 text-destructive' />
	)
}
